import { EFetchStatus } from '../../types/listingOffers';
import { IApplicationState } from '../../types/redux';

export const selectIsOffersLoading = (state: IApplicationState) => {
  return state.listingOffers.status === EFetchStatus.LOADING;
};
